import { api } from '@/global/services/api'

const state = {
  showItem: null,
  viewConfig: {},
  permissions: {}
}

const getters = {
  showItem: state => state.showItem,
  viewConfig: state => state.viewConfig,
  permissions: state => state.permissions
}

const actions = {
  async fetch ({ commit, state }, id) {
    try {
      const { config, data, permissions } = await api().people.get(`people/${id}/details`)

      commit('SET_SHOW_ITEM', data)
      commit('SET_VIEW_CONFIG', config)
      commit('SET_PERMISSIONS', permissions)
    }
    catch (e) {
      console.dir(e)
    }
  },

  setShowItem ({ commit }, data) {
    commit('SET_SHOW_ITEM', data)
  }
}

const mutations = {
  SET_SHOW_ITEM: (state, payload) => (state.showItem = payload),
  SET_VIEW_CONFIG: (state, payload) => (state.viewConfig = payload),
  SET_PERMISSIONS: (state, payload) => (state.permissions = payload)
}

export default {
  state,
  getters,
  actions,
  mutations
}
